// extracted by mini-css-extract-plugin
export default {"subject_unread":"E6rx0ofkSU","receivedDate":"dNEf8FORmw","iconList":"VMLx05RLJt"};